<template>
  <div class="team-page">
    <van-nav-bar
      :title="$t('m.td_span0')"
      fixed
      placeholder
      :border="false"
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="team-hero">
      <div class="hero-user">
        <img class="hero-avatar" :src="avatarSrc" alt="" />
        <div class="hero-meta">
          <div class="hero-name-row">
            <span class="hero-name">{{ displayName }}</span>
            <!-- <span class="hero-tag">团队长</span> -->
          </div>
          <div class="hero-invite">
            <span>我的邀请码</span>
            <b>{{ inviteCode || "--" }}</b>
            <button
              v-if="inviteCode"
              type="button"
              class="hero-copy"
              @click="copyText(inviteCode)"
            >
              复制
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="team-body">
      <div class="stats-card">
        <div class="stat-item" v-for="item in statItems" :key="item.label">
          <div class="stat-num">{{ formatCount(item.value) }}</div>
          <div class="stat-label">{{ item.label }}</div>
          <div class="stat-icon" :style="{ color: item.color }">
            <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
              <path
                fill="currentColor"
                d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5C15 14.17 10.33 13 8 13zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
              />
            </svg>
          </div>
        </div>
      </div>

      <div class="today-card">
        <div class="today-copy">
          <div class="today-label">今日注册人数</div>
          <div class="today-num">
            {{ formatCount(todayCount) }} <span>人</span>
          </div>
        </div>
        <svg
          class="today-wave"
          viewBox="0 0 120 48"
          preserveAspectRatio="none"
          aria-hidden="true"
        >
          <path
            d="M0 30 C18 12, 28 40, 48 24 C68 8, 82 36, 100 20 C110 12, 116 18, 120 16"
            fill="none"
            stroke="var(--bg-color)"
            stroke-width="2.4"
            stroke-linecap="round"
            opacity="0.45"
          />
          <path
            d="M0 36 C20 22, 34 42, 54 30 C74 18, 90 40, 120 26"
            fill="none"
            stroke="var(--bg-color)"
            stroke-width="1.6"
            stroke-linecap="round"
            opacity="0.22"
          />
        </svg>
      </div>

      <div class="dist-card">
        <div class="card-title">团队分布</div>
        <div class="dist-row" v-for="row in distRows" :key="row.level">
          <span class="dist-badge" :style="{ background: row.color }">{{
            row.level
          }}</span>
          <span class="dist-name">{{ row.name }}</span>
          <span class="dist-count"
            >{{ formatCount(row.value) }} <em>人</em></span
          >
        </div>
      </div>

      <div class="invite-card">
        <div class="card-title">邀请链接</div>
        <p class="invite-tip">分享链接，邀请好友加入您的团队</p>
        <div class="invite-box">
          <div class="invite-url">{{ inviteLink }}</div>
          <button type="button" class="invite-copy" @click="copyText(inviteLink)">
            复制链接
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getMyUserInfo } from "@api/user";
import request from "@utils/request";

export default {
  name: "team",
  data() {
    return {
      userInfo: {},
      defaultAvatar: require("../../assets/images/new/user-list.png"),
      totalCount: 0,
      todayCount: 0,
      level1Count: 0,
      level2Count: 0,
      level3Count: 0,
      inviteFromApi: ""
    };
  },
  computed: {
    displayName() {
      return (
        this.userInfo.nickname ||
        this.userInfo.realname ||
        this.userInfo.username ||
        "用户"
      );
    },
    avatarSrc() {
      return this.userInfo.avatar || this.defaultAvatar;
    },
    inviteCode() {
      return this.userInfo.invite || this.inviteFromApi || "";
    },
    inviteLink() {
      const origin = window.location.origin;
      const path = (window.location.pathname || "/").replace(/\/$/, "");
      const code = this.inviteCode ? encodeURIComponent(this.inviteCode) : "";
      return origin + path + "#/register?invite=" + code;
    },
    statItems() {
      return [
        {
          label: "团队总人数",
          value: this.totalCount,
          color: "var(--bg-color)"
        },
        { label: "一级人数", value: this.level1Count, color: "#e53935" },
        { label: "二级人数", value: this.level2Count, color: "#ff6b35" },
        { label: "三级人数", value: this.level3Count, color: "#ff9800" }
      ];
    },
    distRows() {
      return [
        {
          level: 1,
          name: "一级成员",
          value: this.level1Count,
          color: "#e53935"
        },
        {
          level: 2,
          name: "二级成员",
          value: this.level2Count,
          color: "#ff6b35"
        },
        {
          level: 3,
          name: "三级成员",
          value: this.level3Count,
          color: "#ff9800"
        }
      ];
    }
  },
  created() {
    this.loadUser();
    this.loadTeam();
  },
  methods: {
    formatCount(value) {
      const num = Number(value || 0);
      return num.toLocaleString("zh-CN");
    },
    loadUser() {
      getMyUserInfo()
        .then(res => {
          this.userInfo = (res.data && res.data.data) || {};
        })
        .catch(() => {});
    },
    loadTeam() {
      request
        .post("/user/team/team", {}, { login: true })
        .then(res => {
          const stats = (res.data && res.data.data && res.data.data.stats) || {};
          this.totalCount = Number(stats.total_count || 0);
          this.todayCount = Number(stats.today_count || 0);
          this.level1Count = Number(stats.level1_count || 0);
          this.level2Count = Number(stats.level2_count || 0);
          this.level3Count = Number(stats.level3_count || 0);
          this.inviteFromApi = stats.invite || "";
        })
        .catch(err => {
          const msg =
            (err.response && err.response.data && err.response.data.msg) ||
            "团队数据加载失败";
          this.$dialog.error(msg);
        });
    },
    copyText(text) {
      if (!text) {
        return;
      }
      const element = this.createElement(text);
      element.select();
      element.setSelectionRange(0, element.value.length);
      document.execCommand("copy");
      element.remove();
      this.$toast.success("您成功复制了" + text);
    },
    createElement(text) {
      const isRTL = document.documentElement.getAttribute("dir") === "rtl";
      const element = document.createElement("textarea");
      element.style.fontSize = "12pt";
      element.style.border = "0";
      element.style.padding = "0";
      element.style.margin = "0";
      element.style.position = "absolute";
      element.style[isRTL ? "right" : "left"] = "-9999px";
      element.style.top = `${window.pageYOffset ||
        document.documentElement.scrollTop}px`;
      element.setAttribute("readonly", "");
      element.value = text;
      document.body.appendChild(element);
      return element;
    },
    onClickLeft() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped lang="less">
.team-page {
  min-height: 100vh;
  background: #f6f6f6;
  padding-bottom: 80px;
}
.team-page /deep/ .van-nav-bar {
  box-shadow: none;
  background-color: transparent;
}
.team-page /deep/ .van-nav-bar__title,
.team-page /deep/ .van-icon {
  color: #fff;
}
.team-hero {
  margin-top: -46px;
  padding: 92px 18px 28px;
  background-image: url(../../assets/images/new/gradient-bg.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-color: var(--bg-color);
}
.hero-user {
  display: flex;
  align-items: center;
}
.hero-avatar {
  width: 54px;
  height: 54px;
  border-radius: 50%;
  border: 3px solid rgba(255, 255, 255, 0.9);
  object-fit: cover;
  background: #fff;
}
.hero-meta {
  margin-left: 12px;
  color: #fff;
  min-width: 0;
  flex: 1;
}
.hero-name-row {
  display: flex;
  align-items: center;
  gap: 8px;
}
.hero-name {
  font-size: 18px;
  font-weight: 700;
  line-height: 1.2;
}
.hero-tag {
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.22);
}
.hero-invite {
  margin-top: 8px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  font-size: 12px;
  opacity: 0.96;
}
.hero-invite b {
  font-size: 13px;
  letter-spacing: 0.5px;
}
.hero-copy {
  border: 1px solid rgba(255, 255, 255, 0.85);
  background: transparent;
  color: #fff;
  border-radius: 10px;
  height: 22px;
  padding: 0 8px;
  font-size: 11px;
  line-height: 20px;
}
.team-body {
  margin-top: -12px;
  padding: 0 12px 12px;
}
.stats-card,
.today-card,
.dist-card,
.invite-card {
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 4px 16px rgba(255, 25, 0, 0.08);
  margin-bottom: 12px;
}
.stats-card {
  display: flex;
  padding: 16px 4px 14px;
}
.stat-item {
  flex: 1;
  text-align: center;
  position: relative;
}
.stat-item + .stat-item::before {
  content: "";
  position: absolute;
  left: 0;
  top: 8px;
  bottom: 18px;
  width: 1px;
  background: #f3e6e6;
}
.stat-num {
  color: var(--bg-color);
  font-size: 22px;
  font-weight: 700;
  line-height: 1.15;
}
.stat-label {
  margin-top: 6px;
  color: #777;
  font-size: 12px;
}
.stat-icon {
  margin-top: 6px;
  display: flex;
  justify-content: center;
}
.today-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 16px 14px;
  overflow: hidden;
}
.today-label {
  color: #666;
  font-size: 13px;
}
.today-num {
  margin-top: 6px;
  color: var(--bg-color);
  font-size: 28px;
  font-weight: 700;
  line-height: 1.1;
}
.today-num span {
  font-size: 14px;
  font-weight: 600;
}
.today-wave {
  width: 42%;
  max-width: 150px;
  height: 48px;
}
.card-title {
  font-size: 16px;
  font-weight: 700;
  color: #222;
}
.dist-card,
.invite-card {
  padding: 16px 16px 8px;
}
.dist-row {
  display: flex;
  align-items: center;
  padding: 14px 0;
  border-top: 1px solid #f5eeee;
}
.dist-row:first-of-type {
  margin-top: 6px;
}
.dist-badge {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.dist-name {
  margin-left: 10px;
  flex: 1;
  color: #333;
  font-size: 14px;
  font-weight: 600;
}
.dist-count {
  color: #333;
  font-size: 15px;
  font-weight: 700;
}
.dist-count em {
  font-style: normal;
  color: #999;
  font-size: 12px;
  font-weight: 500;
  margin-left: 2px;
}
.invite-tip {
  margin: 6px 0 12px;
  color: #999;
  font-size: 12px;
}
.invite-box {
  display: flex;
  align-items: center;
  background: #fff5f4;
  border-radius: 10px;
  padding: 6px 6px 6px 12px;
  margin-bottom: 10px;
}
.invite-url {
  flex: 1;
  min-width: 0;
  color: #666;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.invite-copy {
  flex-shrink: 0;
  height: 32px;
  padding: 0 12px;
  border: 0;
  border-radius: 8px;
  background: var(--bg-color);
  color: #fff;
  font-size: 12px;
  font-weight: 700;
}
</style>
